module.exports = __webpack_public_path__ + "img/hr.2a402c7d.png";